import type { Theme, Components } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function Menu(theme: Theme): Components<Theme> {
  return {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          ...theme.typography.body2,
          "&.Mui-selected": {
            backgroundColor: theme.palette.action.selected,
            "&:hover": {
              backgroundColor: theme.palette.action.hover,
            },
          },
        },
      },
    },
  };
}
